export default {
  'contact.eyebrow': 'Chúng tôi luôn sẵn sàng hỗ trợ',
  'contact.title': 'Liên hệ',
  'contact.subtitle': 'Hãy kể cho chúng tôi về hành trình Việt Nam trong mơ của bạn. Chuyên gia địa phương sẽ phản hồi trong vòng 24 giờ để giúp tạo nên chuyến đi thực sự của riêng bạn.',
  'contact.home': 'Trang chủ',
  'contact.contact': 'Liên hệ',
  'contact.getInTouch': 'Liên hệ trực tiếp',
  'contact.callUs': 'Gọi cho chúng tôi',
  'contact.email': 'Email',
  'contact.headquarters': 'Trụ sở chính',
  'contact.officeHours': 'Giờ làm việc',
  'contact.formTitle': 'Gửi tin nhắn cho chúng tôi',
  'contact.interestedIn': 'Tôi quan tâm đến tour:',
  'contact.formSubtitle': 'Điền vào biểu mẫu và chúng tôi sẽ phản hồi sớm nhất có thể.',
  'contact.fullName': 'Họ và tên',
  'contact.phone': 'Điện thoại',
  'contact.topic': 'Chủ đề',
  'contact.message': 'Tin nhắn',
  'contact.yourName': 'Tên của bạn',
  'contact.emailPlaceholder': 'ban@example.com',
  'contact.phonePlaceholder': '+84 ...',
  'contact.messagePlaceholder': 'Hãy kể về kế hoạch du lịch, ngày đi và ai sẽ đi cùng bạn...',
  'contact.topicGeneral': 'Yêu cầu chung',
  'contact.topicTailor': 'Tour thiết kế riêng',
  'contact.topicBooking': 'Đặt tour hiện có',
  'contact.topicPartnership': 'Hợp tác',
  'contact.topicFeedback': 'Góp ý',
  'contact.sending': 'Đang gửi...',
  'contact.send': 'Gửi tin nhắn',
  'contact.success': 'Cảm ơn bạn! Tin nhắn đã được gửi. Chuyên gia địa phương sẽ phản hồi bạn sớm.',
  'contact.errorGeneric': 'Đã xảy ra lỗi. Vui lòng thử lại sau.',
  'contact.errorNetwork': 'Đã xảy ra lỗi mạng. Vui lòng kiểm tra kết nối và thử lại.',
  'contact.address': 'Số 10/2, Ngách 29, Ngõ 264, Tổ 13, Phường Bồ Đề, Hà Nội',
  'contact.hours': 'Thứ 2 – Thứ 7, 8:00 – 18:00 (GMT+7)',
  'contact.heroAlt': 'Liên hệ du lịch Việt Nam',
  'contact.mapTitle': 'Vị trí trụ sở du lịch Việt Nam',
  'contact.captchaRequired': 'Vui lòng xác nhận bạn không phải robot.',
  'contact.captchaFailed': 'Xác minh bảo mật thất bại. Vui lòng thử lại.',
};